import { EntityType } from '../modules/shared-entities/types/sharedEntities.enum';
import { IGetSharedEntityResponse } from '../modules/shared-entities/types/sharedEntities.types';

export const returnOrderIdBasedOnPublicOrder = (
  sharedEntity?: IGetSharedEntityResponse | null,
  selectedOrderId?: string,
) => {
  const isPublicLink = !!sharedEntity?.id;
  const isPublicOrder = isPublicLink && sharedEntity?.entity === EntityType.Order;
  const orderId = isPublicOrder ? sharedEntity?.entityId : selectedOrderId;

  return orderId;
};
